module.exports = __webpack_public_path__ + "static/features-41484f84b897608c3dd0a8f35c712b5c.webp";